import { useValidateEmail } from '@/hooks'
import { createValidateEmail } from '../hooks/validations/createValidateEmail'
import { useTexts } from '../hooks/useTexts'

import { form } from '../formState'

export function Email() {
  const texts = useTexts()
  const validateEmail = useValidateEmail()

  form.useAddFieldValidation<'email'>('email', async (field, _formApi) => {
    const emailValidation = await createValidateEmail(texts, field.value, validateEmail)
    return emailValidation.emailRequiredError?.message || emailValidation.invalidEmailError?.message
  })

  return (
    <form.TextField
      name="email"
      testId="email"
      label={texts.labels.email}
      placeholder={texts.placeholders.email}
      validateOn="change"
    />
  )
}
